import React, { useState } from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';

import { formatRelativeTime } from 'utils/formatRelativeTime';
import { TransactionDrawer } from 'features/transactions';

import { StatusBadge } from './components/StatusBadge';
import { AvatarDisplay } from './components/AvatarDisplay';
import { TransactionText } from './components/TransactionText';

export const Transaction = ({ transaction, shouldAnimate }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const Wrapper = shouldAnimate ? motion.div : 'div';

  const { status = 'pending', createdAt } = transaction;
  const timeAgo = formatRelativeTime(createdAt);

  console.log(transaction)

  return (
    <>
      <Wrapper
        onClick={() => setIsDrawerOpen(true)}
        className={clsx(
          'rounded-full p-1 mb-1 px-3 border border-white/10 cursor-pointer backdrop-blur-md transition-all hover:shadow-xl hover:scale-[1.015] text-white bg-white/5'
        )}
        animate={
          shouldAnimate
            ? {
                boxShadow: [
                  '0 0 12px rgba(0,255,255,0.2)',
                  '0 0 24px rgba(255,0,200,0.3)',
                ],
              }
            : {}
        }
        transition={
          shouldAnimate
            ? { duration: 2, repeat: Infinity, ease: 'easeInOut' }
            : {}
        }
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <AvatarDisplay transaction={transaction} />
            <span className="text-sm font-medium ml-2">
              <TransactionText transaction={transaction} />
            </span>
          </div>
          <div className="text-right space-y-1">
            <StatusBadge status={status} />
            <span className="text-xs text-white/50">{timeAgo}</span>
          </div>
        </div>
      </Wrapper>

      <TransactionDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        transaction={transaction}
      />
    </>
  );
};
